/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_MoreInputs */

const en_ui_more = /** @type {(inputs: Ui_MoreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More`)
};

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const ar_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const he_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const ur_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const es_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const fr_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const de_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const pt_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const hi_ui_more = en_ui_more;

/** @type {(inputs: Ui_MoreInputs) => LocalizedString} */
const bn_ui_more = en_ui_more;

/**
* | output |
* | --- |
* | "More" |
*
* @param {Ui_MoreInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const ui_more = /** @type {((inputs?: Ui_MoreInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_MoreInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_ui_more(inputs)
	if (locale === "he") return he_ui_more(inputs)
	if (locale === "ur") return ur_ui_more(inputs)
	if (locale === "es") return es_ui_more(inputs)
	if (locale === "fr") return fr_ui_more(inputs)
	if (locale === "de") return de_ui_more(inputs)
	if (locale === "pt") return pt_ui_more(inputs)
	if (locale === "hi") return hi_ui_more(inputs)
	if (locale === "bn") return bn_ui_more(inputs)
	return /** @type {LocalizedString} */ ("More")
});